// extracted by mini-css-extract-plugin
export default {"error":"HandelFetchComponents_error__XUAJu","classPositioned":"HandelFetchComponents_classPositioned__-Do8G"};